import { IsInt } from 'class-validator';

import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

export class SidekickConfig {
  @IsInt()
  v1CustomerId: number;
}

const sidekickConfigurationResource = createDocumentResource<SidekickConfig>({
  name: 'sidekickConfiguration',
  endpoint: 'v1/orgs/:orgId/configuration/sidekick',
  type: SidekickConfig,
  observerCreator: emptyObserverCreator,
});

export default sidekickConfigurationResource;
